<template lang="html">
	<transition name="fade">
		<div
			class="modal-student-card bg-color container column justify-content-center align-items-center"
			v-if="show"
		>
			<div
				class="modal-student-card__close container padding-10 justify-content-end"
			>
				<button
					id="close_student-card"
					class="btn btn-sm btn-blue btn-rounded"
					@click="$store.commit('setShowStudentCard', false)"
				>
					<font-awesome-icon icon="times"/>
				</button>
			</div>
			<div
				class="modal-student-card__box container padding-10 justify-content-center align-center flex-grow-1"
			>
				<div class="modal-student-card__box__card container" :class="{ rotate: rotateCard }" @click="rotateCard = !rotateCard">
					<div class="modal-student-card__box__card__front flex-grow-1 container column justify-content-end padding-20">
						<div>
							<img style="float: right" src="@/assets/img/logos/logo.svg" width="137" class="logo" alt="Minds">
						</div>
						<div class="flex-grow-1">

						</div>
						<div class="modal-student-card__box__card__front__name">
							{{ student.name }}
						</div>
						<div class="modal-student-card__box__card__front__birth">
							Nascimento: {{ new Date(student.birth).toLocaleDateString() }}
						</div>
					</div>
					<div class="modal-student-card__box__card__back flex-grow-1 container column justify-content-end padding-20">
						<div>
							<img src="@/assets/img/logos/logo.svg" width="137" class="logo" alt="Minds">
						</div>
						<div class="flex-grow-1">

						</div>
						<div class="modal-student-card__box__card__back__score">
							Pontos: {{ student.score }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>
  
<script>
  export default {
    name: 'LoaderModal',
    data () {
      return {
				rotateCard: false
      }
    },
    computed: {
      show () {
        return this.$store.getters['showStudentCard']
      },
			student () {
				return this.$store.getters['student/GET']
			}
    },
    methods: {
			
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .modal-student-card {
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 125;
    &__close {
      width: 100%;
      padding-bottom: 5px;
      button#close_student-card svg,
      button#back_student-card svg {
        font-size: 32px;
      }
    }
  
    &__box {
      width: calc(100% - 20px);
      margin: 10px;
			
			&__card {
				width: 322px;
				height: 200px;
				background: transparent;
				position: relative;
				transition: transform 0.6s;
				transform-style: preserve-3d;
				box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
				border-radius: 20px;

				&__front {
					width: 100%;
					height: 100%;
					position: absolute;
					background: linear-gradient(270deg, #CD1F26 0%, #C50737);
					backface-visibility: hidden;
					border-radius: 20px;

					&__name {
						font-size: 18px;
					}

					&__birth {
						font-size: 14px;
					}
				}

				&__back {
					width: 100%;
					height: 100%;
					position: absolute;
					background: linear-gradient(270deg, #01699e 0%, #06355d);
					backface-visibility: hidden;
					transform: rotateY(180deg);
					border-radius: 20px;

					&__score {
						text-align: right;
						font-size: 14px;
					}
				}

				&.rotate {
					transform: rotateY(180deg);
				}
			}
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/modal/modalStudentCard.vue